export const ZhChtChatStrings = {
  HEADER_ANNOUNCEMENT: "公告",
  HEADER_GROUP: "群組",
  HEADER_INDIVIDUAL: "聯絡人",
  HEADER_FAVORITE: "最愛",
  HEADER_ARCHIVED: "已封存",
  HEADER_MESSAGE: "訊息",

  ADD_FAVORITE: "加到最愛",
  REMOTE_FAVORITE: "從最愛中移除",
  SEE_MORE: "查看更多",

  CONFIRM_FORWARD: "確定轉發訊息到 {{USER_NAME}}?",

  RECEIVED_FILE: "收到檔案",
  SENT_FILE: "發送了檔案",
  POLL_VOTED_PREFIX: "你已投票:",
  RECEIVED_STICKER: "{{SENDER}} 傳送了貼圖",
  SENT_STICKER: "貼圖已傳送",
  RECEIVED_STARTED_VIDEOCALL: "通話已開始",
  RECEIVED_ENDED_VIDEOCALL: "通話已結束",
  SENT_STARTED_VIDEOCALL: "通話已開始",
  SENT_ENDED_VIDEOCALL: "通話已結束",
  REMOVE: "刪除",
  ADD_ARCHIVE: "封存",
  REMOTE_ARCHIVE: "取消封存",

  NEW_GROUP: "建立群組",
  BROADCAST: "廣播",
  SEARCH_MESSAGE: "搜尋訊息",
  SORT_TIME: "依時間排序",
  SORT_GROUP: "依群組排序",
  SEARCH_UNFILTERED: "篩選",
  SEARCH_FILTERED_ONE: "已篩選1名用戶",
  SEARCH_FILTERED_MANY: "已篩選{{COUNT}}名用戶",

  RESTRICTED_CHAT_OPEN_IN_APP_MSG: "基於安全原因，此聊天室只能在App中打開。",
  CONFIDENTIAL_MSG_PREVIEW: "**機密訊息**",

  ENCRYPTED_MSG_PREVIEW: "**安全訊息**",

  CHAT_GROUP: {
    GROUP_NAME: "群組名稱",
    ADD_MEMBER: "新增群組成員",
    ADD_MEMBER_FROM_CHAT_GROUP: "從其它群組新增成員",
    ADD_MEMBER_FROM_BROADCAST: "從廣播列表新增成員",
    NO_MEMBER: "沒有群組成員",
    MEMBER_COUNT: {
      ONE: "{{NUM}}位群組成員",
      MULTIPLE: "{{NUM}}位群組成員"
    },
    NORMAL_GROUP: "一般群組",
    ANNOUNCEMENT_GROUP: "公告群組",
    GROUP_TYPE: "群組類型",
    GORUP_LEVEL: "訊息分級",

    ERROR_MSG: {
      NO_GROUP_NAME: "請輸入群組名稱",
      NO_MEMBER: "請選擇群組成員"
    },

    ASSIGN_ADMIN: "指派群組管理員",
    ADD_ADMIN: "新增群組管理員",
    REMOVE_MEMBER: "移除群組成員",
    REMOVE_MEMBER_CONFIRM: "確認要將 {{USER}} 從群組中移除?",
    NOTIFICATION: {
      TITLE: "靜音通知",
      ONE_HOUR: "1 小時",
      TWO_HOURS: "2 小時",
      EIGHT_HOURS: "8 小時",
      ONE_WEEK: "1 星期",
      ONE_YEAR: "1 年",
      FOREVER: "永久",
      UNTIL: "直到 "
    },
    LEAVE_GROUP: "離開群組",
    LEAVE_GROUP_CONFIRM: "確定要離開此群組?",
    DELETE_GROUP: "刪除群組",
    DELETE_GROUP_CONFIRM: "確定要刪除群組?",
    REMOVE_ALL: "刪除所有已選擇的成員"
  },
  
  CONTACT_CARD: {
    WHISPER: "私訊",
    CHAT: "聊天",
    IMPORTANT_USER: {
      SET: "重要用戶",
      UNSET: "非重要用戶"
    }
  }

}
